import { render, staticRenderFns } from "./veStuCheckBj.vue?vue&type=template&id=3946fbc1&scoped=true"
import script from "./veStuCheckBj.vue?vue&type=script&lang=js"
export * from "./veStuCheckBj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946fbc1",
  null
  
)

export default component.exports